import React from 'react';
import clsx from 'clsx';
import './index.pc.scss';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcInputLine from 'components/molecules/PcInputLine';
import PcInputTitleMessage from 'components/molecules/PcInputTitleMessage';
import PcMarketPrice from 'components/molecules/PcMarketPrice';
import TypeRadio from 'components/atoms/Input/TypeRadio';
import DropdownInput from 'components/atoms/Input/DropdownInput';
import CheckBoxInput from 'components/atoms/Input/CheckBoxInput';
import CalendarInput from 'components/atoms/Input/CalendarInput';
import NormalCheckBoxInput from 'components/atoms/Input/NormalCheckBoxInput';
import TextBox from 'components/atoms/Input/TextBox';
import TextAreaBox from 'components/atoms/Input/TextAreaBox';
import PcErrorArea from 'components/molecules/PcErrorArea';


const PresentPC = ({
  // 就業期間from
  tommorow,
  fromDate,
  calFromPlaceholder,
  handleChangeFromDate,
  // 就業期間to
  minToDate,
  toDate,
  handleChangeToDate,
  pendingToDateFlag,
  handleChangeToDateFlag,
  calToPlaceholder,
  // 勤務形態
  workStyle,
  handleChangeWorkStyle,
  workStyleList,
  // 就業日数
  minBusinessDayList,
  minBusinessDay,
  handleChangeMinBusinessDay,
  maxBusinessDayList,
  maxBusinessDay,
  handleChangeMaxBusinessDay,
  // 就業曜日
  dayOfTheWeekList,
  dayOfTheWeek,
  handleChangeDayOfTheWeek,
  // シフト区分
  workStyleKbn,
  handleChangeWorkStyleKbn,
  workStyleKbnList,
  // 就業時間from 固定勤務
  startHourList,
  fixedStartHour,
  handleChangeFixedStartHour,
  startMinList,
  fixedStartMin,
  handleChangeFixedStartMin,
  // 就業時間to 固定勤務
  endHourList,
  fixedEndHour,
  handleChangeFixedEndHour,
  endMinList,
  fixedEndMin,
  handleChangeFixedEndMin,
  // 休憩時間 固定勤務
  restTimeList,
  fixedRestTime,
  handleChangeFixedRestTime,
  // 就業時間 早番~夜勤
  ShiftTypeList,
  // 車通勤
  canCommuteByCar,
  handleChangeCanCommuteByCar,
  canCommuteByCarList,
  // 時給、サジェスト
  hourSalary,
  handleChangeHourSalary,
  suggestHourSalaryDisp,
  // その他条件
  freeComment,
  handleChangeFreeComment,  
  // 更新、エラーチェック
  onClickMainButton,
  valid,
  errorDispMap,
  isApiError,
  warn,
  lpMode,
}) => (
  <div className="Cond">
    <PcBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      isApiError={isApiError}
      lpMode={lpMode}
    >
    
      {/* 就業期間 */}
      <PcInputTitleMessage 
        title="期間"
        message="※31日以上を選択してください"
      >
        <CalendarInput 
          minDate={tommorow}
          selected={fromDate}
          handleChange={handleChangeFromDate}
          placeholder={calFromPlaceholder}
        />
        <div className="P-C-from-to">~</div>
        <CalendarInput 
          minDate={minToDate}
          selected={toDate}
          handleChange={handleChangeToDate}
          radioSelected={pendingToDateFlag}
          radioChange={handleChangeToDateFlag}
          placeholder={calToPlaceholder}
        />
        <PcErrorArea message={errorDispMap.syuugyouKikan} />
      </PcInputTitleMessage>

      {/* 勤務形態 */}
      <div className="pc-workStyle">
        <PcInputLine title="勤務形態">
          {workStyleList.map((label)=>{
            return(
              <TypeRadio
                key={label.label}
                value={label.value}
                onChange={handleChangeWorkStyle}
                checked={workStyle === label.value}
                label={label.label}
              />
            );
          })}
        </PcInputLine>
      </div>

      {/* 就業日数 */}
      <PcInputLine title="就業日数/週">
        <DropdownInput
          items={minBusinessDayList}
          selectedValue={minBusinessDay}
          onChange={handleChangeMinBusinessDay}
        />
        <div className="P-C-label">日</div>
        <div className="P-C-wave">~</div>
        <DropdownInput
          items={maxBusinessDayList}
          selectedValue={maxBusinessDay}
          onChange={handleChangeMaxBusinessDay}
        />
        <div className="P-C-label">日</div>
        <PcErrorArea message={errorDispMap.businessDay} />
      </PcInputLine>

      {/* 就業曜日 */}
      <span className="week">
        <PcInputLine title="就業曜日">
          {dayOfTheWeekList.map((label) => {
            return (
              <CheckBoxInput
                checked={dayOfTheWeek.includes(label.value)}
                key={label.value}
                label={label.label}
                onChange={handleChangeDayOfTheWeek}
                value={label.value}
              />
            );
          })}
          <PcErrorArea message={errorDispMap.dayOfTheWeek} />
        </PcInputLine>
      </span>

      {/* 勤務形態によってだし分け */}
      <div className={clsx(
        'selectedShift',
        { fixed: workStyle === '01' },
        { shift: workStyle === '02' },
        { other: workStyle !== '01' && workStyle !== '02' },
      )}
      >
        {/* シフト区分 シフト勤務が選択された場合に表示 */}
        <div className="pc-shift">
          <PcInputLine title="シフト区分">
            {workStyleKbnList.map((label) => {
              return (
                <NormalCheckBoxInput
                  id={label.label}
                  key={label.label}
                  checked={workStyleKbn.includes(label.value)}
                  label={label.label}
                  onChange={handleChangeWorkStyleKbn}
                  value={label.value}
                  color="0"
                />
              );
            })}
            <PcErrorArea message={errorDispMap.workStyleKbn} />
          </PcInputLine>
        </div>
        
        {/* 就業時間 固定勤務が選択された場合に表示 */}
        <div className="pc-fixed">
          <PcInputLine title="就業時間">
            <span className="syuugyouTime-input">
              {/* 開始（時：分） */}
              <DropdownInput
                items={startHourList}
                selectedValue={fixedStartHour}
                onChange={handleChangeFixedStartHour}
              />
              <div className="P-C-colon">:</div>
              <DropdownInput
                items={startMinList}
                selectedValue={fixedStartMin}
                onChange={handleChangeFixedStartMin}
              />

              <div className="P-C-wave">~</div>
        
              {/* 終了（時：分） */}
              <DropdownInput
                items={endHourList}
                selectedValue={fixedEndHour}
                onChange={handleChangeFixedEndHour}
              />
              <div className="P-C-colon">:</div>
              <DropdownInput
                items={endMinList}
                selectedValue={fixedEndMin}
                onChange={handleChangeFixedEndMin}
              />
              <PcErrorArea message={errorDispMap.syuugyouTimeFixed} /> 
          
              {/* 休憩時間 */}
              <div className="restTime-title">
                休憩
              </div>
              <DropdownInput
                items={restTimeList}
                selectedValue={fixedRestTime}
                onChange={handleChangeFixedRestTime}
              />
              <div className="P-C-label">分</div>
            </span>
          </PcInputLine>
        </div>

        {/* 就業時間 早番,日勤,遅番,夜勤 */}
        <div className="shiftWorkTime">
          {ShiftTypeList.map((shiftType)=>{
            const { 
              value,
              title,
              syuugyouTimeErrors,
              startHourState,
              startHourOnChange,
              startMinState,
              startMinOnChange,
              endHourState,
              endHourOnChange,
              endMinState,
              endMinOnChange,
              RestTimeState,
              RestTimeOnChange,
            } = shiftType;
            
            if(workStyleKbn.includes(value.value)){
              return(
                <PcInputLine title={title} key={title}>
                  <span className="syuugyouTime-input">
                    {/* 開始（時：分） */}
                    <DropdownInput
                      items={startHourList}
                      selectedValue={startHourState}
                      onChange={startHourOnChange}
                    />
                    <div className="P-C-colon">:</div>
                    <DropdownInput
                      items={startMinList}
                      selectedValue={startMinState}
                      onChange={startMinOnChange}
                    />
  
                    <div className="P-C-wave">~</div>
          
                    {/* 終了（時：分） */}
                    <DropdownInput
                      items={endHourList}
                      selectedValue={endHourState}
                      onChange={endHourOnChange}
                    />
                    <div className="P-C-colon">:</div>
                    <DropdownInput
                      items={endMinList}
                      selectedValue={endMinState}
                      onChange={endMinOnChange}
                    />
                    <PcErrorArea message={syuugyouTimeErrors} /> 
            
                    {/* 休憩時間 */}
                    <div className="restTime-title">
                      休憩
                    </div>
                    <DropdownInput
                      items={restTimeList}
                      selectedValue={RestTimeState}
                      onChange={RestTimeOnChange}
                    />
                    <div className="P-C-label">分</div>
                  </span>
                </PcInputLine>
              );
            }
            return(
              <div key={title} />
            );
          })}
        </div>
      </div>

      {/* 車通勤 */}
      <div className="pc-canCommuteByCar">
        <PcInputLine title="車通勤">
          <DropdownInput
            items={canCommuteByCarList}
            onChange={handleChangeCanCommuteByCar}
            selectedValue={canCommuteByCar}
          />
          <PcErrorArea message={errorDispMap.canCommuteByCar} />
        </PcInputLine>
      </div>

      {/* 時給 */}
      <PcInputLine title="希望単価/時">
        <span className="salary">
          <span className="textMiddle">
            <TextBox
              name="hourSalary"
              val={hourSalary}
              onChange={handleChangeHourSalary}
              maxLength="4"
            />
            <span className="yenMargin">円</span>
            <PcErrorArea message={errorDispMap.hourSalary} position="relative" message2row />
            <PcErrorArea message={warn.hourSalary} position="relative" message2row />
          </span>
        </span>
        <span className="marketPrice">
          <PcMarketPrice
            type="two"
            suggestHourSalaryDisp={suggestHourSalaryDisp}
          />
        </span>
      </PcInputLine>

      {/* その他条件 */}
      <PcInputLine 
        title="その他条件"
        optional="true"
      >
        <span className="textArea">
          <TextAreaBox
            name="freeComment"
            value={freeComment}
            onChange={handleChangeFreeComment}
            maxLength="200"
            placeholder="残業などがある場合は必ず詳細をご記入ください"
            inValid={!!errorDispMap.freeComment}
          />
          <PcErrorArea message={errorDispMap.freeComment} />
        </span>
      </PcInputLine>
      
    </PcBasicTemplate>
  </div>
);


export default PresentPC;
